import React, {Component} from 'react';
import axios from "axios";
import * as ROUTES from "../../constants/routes";
import { ClockLoader} from "react-spinners";
import {css} from "@emotion/core";
import {BACKEND_BASE_URL} from "../../constants/routes";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class AdminLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {...this.INITIAL_STATE}
    }


    INITIAL_STATE = {
        email: '',
        password: '',
        error: null,
        user: '',
        loading: false

    };

    updateUser(user){
        this.props.updateNewUser(user)
    }
    onSubmit = event => {
        this.setState({loading:true})
        const { email, password, loading } = this.state;
        axios.post(`${BACKEND_BASE_URL}/admin/admin_area`, {
            type : "workers",
            email: email,
            password:password
        }).then(
            res=> {
                this.setState({loading:false})
                this.setState({ user: res.data.data})
                this.updateUser(res.data.data)
                this.props.history.push(ROUTES.HOME);

            }).catch(error=>{
            if (error.response) {
                if (error.response==="404"){
                    this.setState({error:error.response.data})

                }else{
                    this.setState({error:"An Error Occurred, Please Try Again Later"})
                }
                // Request made and server responded
                console.log(error.response.data.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            this.setState({loading:false})
        })


        // this.props.firebase
        //     .doSignInWithEmailAndPassword(email, password)
        //     .then(() => {
        //         this.setState({ ...INITIAL_STATE });
        //         this.props.history.push(ROUTES.HOME);
        //     })
        //     .catch(error => {
        //         this.setState({ error });
        //     });
        event.preventDefault();
    };
    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    render() {
        const { email, password, error } = this.state;
        const isInvalid = password === '' || email === '';
        return (
            <html lang="en">
            <head>
                <title>Login V3</title>
                <link rel="icon" type="image/png" href="images/icons/favicon.ico"/>
                <link rel="stylesheet" type="text/css" href="vendor/bootstrap/css/bootstrap.min.css"/>
                <link rel="stylesheet" type="text/css" href="fonts/font-awesome-4.7.0/css/font-awesome.min.css"/>
                <link rel="stylesheet" type="text/css" href="fonts/iconic/css/material-design-iconic-font.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/animate/animate.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/css-hamburgers/hamburgers.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/animsition/css/animsition.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/select2/select2.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/daterangepicker/daterangepicker.css"/>
                <link rel="stylesheet" type="text/css" href="css/util.css"/>
                <link rel="stylesheet" type="text/css" href="css/main.css"/>
            </head>
            <body>

            <div className="limiter">
                <div className="container-login100" style={{backgroundImage: "url('images/bgm.jpg')" }}>
                    <div className="wrap-login100">

                        <div className="sweet-loading">
                            <ClockLoader
                                css={override}
                                size={100}
                                //size={"150px"} this also works
                                color={"#123abc"}
                                loading={this.state.loading}
                            />


                        </div>
                        <form className="login100-form validate-form" onSubmit={this.onSubmit}>
					<span className="login100-form-logo">
                        <img src={"images/supwork_logo_dark.svg"} height={50} width={50} className={"zmdi"}/>
                        {/*<i className="zmdi zmdi-landscape"></i>*/}
					</span>

                            <span className="login100-form-title p-b-34 p-t-27">
						Log in
                        <h3 className={"text-danger"}>{error}</h3>

					</span>



                            <div className="wrap-input100 validate-input" data-validate = "Enter username">
                                <input className="input100" type="text"   placeholder={"Email/E-postanızı giriniz"}     name="email" value={email} onChange={this.onChange}/>
                                <span className="focus-input100" data-placeholder="&#xf207;"></span>
                            </div>

                            <div className="wrap-input100 validate-input" data-validate="Enter password">
                                <input className="input100" type="password"     name="password" value={password} onChange={this.onChange} placeholder="Password/şifre"/>
                                <span className="focus-input100" data-placeholder="&#xf191;"></span>
                            </div>

                            <div className="contact100-form-checkbox">
                                <input className="input-checkbox100" id="ckb1" type="checkbox" name="remember-me"/>
                                <label className="label-checkbox100" htmlFor="ckb1">
                                    Remember me
                                </label>
                            </div>

                            <div className="container-login100-form-btn">
                                <button className="login100-form-btn">
                                    Login
                                </button>
                            </div>


                            <div className="text-center p-t-90">
                                <a className="txt1" href="#">
                                    Forgot Password?
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>


            <div id="dropDownSelect1"></div>

            <script src="vendor/jquery/jquery-3.2.1.min.js"></script>
            <script src="vendor/animsition/js/animsition.min.js"></script>
            <script src="vendor/bootstrap/js/popper.js"></script>
            <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
            <script src="vendor/select2/select2.min.js"></script>
            <script src="vendor/daterangepicker/moment.min.js"></script>
            <script src="vendor/daterangepicker/daterangepicker.js"></script>
            <script src="vendor/countdowntime/countdowntime.js"></script>
            <script src="js/main.js"></script>

            </body>
            </html>


        );
    }
}

export default AdminLogin;